module.exports = __webpack_public_path__ + "img/A6.475300c2.svg";